import { GlobalStyle } from '../../styles/global-styles'
import { useContext, useState } from 'react'
import HeroBanner from '../../components/hero-banner/hero-banner'
import FaqContent from '../../components/faq/faq'
import logAnalyticsEvent from '../../utilities/firebase-analytics'
import { LoginContext } from '../../contexts/login-context'
import { ApiContext } from '../../contexts/api-context'
import FaqCategoryButtons from '../../components/faq/faq-category'

const FaqPage = () => {
  const { user } = useContext(LoginContext)
  const { userProfile } = useContext(ApiContext)
  const [selectedSection, setSelectedSection] = useState(0)

  logAnalyticsEvent('page_view', {
    page_location: '/faq',
    page_title: 'Faq',
    user: user?.email,
    team: userProfile?.team
  })
  return (
    <>
      <GlobalStyle page="faq" />
      <HeroBanner
        subHeading="FAQs"
        heading="Frequently Asked Questions"
        supportingText="Need help? We're here to support you!"
      />
      <FaqCategoryButtons selected={selectedSection} setSelected={setSelectedSection} />
      <FaqContent selectedNum={selectedSection} />
    </>
  )
}

export default FaqPage
